// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"124":"bb52b7942b5ce39b","475":"27a7bcedc7f8dfe9","2030":"ffec63e5f96ab59b","8445":"340d3bbb0efa344f"}[chunkId] + ".css";
};